/**
 * Rewrite ActiveStorage / API asset URLs that point at localhost (or are relative)
 * so previews work when the CRA app runs on a different origin than the API.
 */
export function resolveApiAssetUrl(url: string | null | undefined): string {
  if (!url) return ''

  const apiBase = process.env.REACT_APP_API_URL?.replace(/\/$/, '')
  if (!apiBase) return url

  try {
    const apiOrigin = new URL(apiBase).origin

    if (url.startsWith('/')) {
      return `${apiOrigin}${url}`
    }

    const parsed = new URL(url)
    if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
      return `${apiOrigin}${parsed.pathname}${parsed.search}${parsed.hash}`
    }

    return url
  } catch {
    return url
  }
}
